export const DEFAULT_THEME = 'default'
export const LIGHT_THEME = 'light'
export const DARK_THEME = 'dark'

export type Themes =
  | typeof DEFAULT_THEME
  | typeof LIGHT_THEME
  | typeof DARK_THEME

export const isLightTheme = (theme: string) => theme === LIGHT_THEME
export const isDarkTheme = (theme: string) => theme === DARK_THEME
